import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CouponDiscount icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CouponDiscount } from '@sravni/design-system-icons'
 *
 * <CouponDiscount />
 * ```
 */
var CouponDiscount = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CouponDiscount", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.75 17.5h2.5M11.25 2.5h-2.5M2.5 8.75v2.5M17.5 11.25v-2.5M7.708 12.292l4.584-4.584M8.384 6.616a1.25 1.25 0 1 1-1.768 1.768 1.25 1.25 0 0 1 1.768-1.768ZM13.384 11.616a1.25 1.25 0 1 1-1.768 1.768 1.25 1.25 0 0 1 1.768-1.768ZM17.5 5V3.512c0-.559-.453-1.012-1.012-1.012H15M2.5 15v1.488c0 .559.453 1.012 1.012 1.012H5M5 2.5H3.512c-.559 0-1.012.453-1.012 1.012V5M15 17.5h1.488c.559 0 1.012-.453 1.012-1.012V15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CouponDiscount };
//# sourceMappingURL=CouponDiscount.js.map
